import { render, staticRenderFns } from "./essentialPCb.vue?vue&type=template&id=4c83a26e&scoped=true&"
import script from "./essentialPCb.vue?vue&type=script&lang=js&"
export * from "./essentialPCb.vue?vue&type=script&lang=js&"
import style0 from "./essentialPCb.vue?vue&type=style&index=0&id=4c83a26e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c83a26e",
  null
  
)

export default component.exports